import React from "react";
import { Flex, Heading, Text, Button, Icon, Image } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";
import {
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
  newBorder,
} from "../../../../utils/colors";
import noServices from "../../../../assets/images/empty-box.png";

const NoItemsDefaultNew = ({
  noItemsTitle,
  noItemsDescription,
  noItemsButtonHandler,
  noItemsButtonLabel,
  noItemsButtonDisabled,
}) => {
  return (
    <Flex
      direction="column"
      justifyContent="center"
      alignItems="center"
      margin="0 auto 0rem"
      p="3rem 0"
      w="100%"
      h="100%"
      borderRadius="0.75rem"
      border="none"
    >
      <Image h="initial" w="3rem" m="0rem 0 0" src={noServices} />
      <Heading
        fontSize="1rem"
        fontWeight="500"
        color={textPrimary}
        margin="1rem 0 0.25rem"
      >
        {noItemsTitle}
      </Heading>
      <Text fontSize="sm" color={textSecondary}>
        {noItemsDescription}
      </Text>
      {noItemsButtonHandler && (
        <Button
          size="md"
          m="1rem 0 0"
          h="2.25rem"
          border={`0px solid ${newBorder}`}
          bg={textPrimary}
          color={white}
          borderRadius="10rem"
          px="1.5rem"
          onClick={noItemsButtonHandler}
          isDisabled={noItemsButtonDisabled}
          _hover={{ bg: primaryAlt }}
        >
          <Icon as={FaPlus} mr="0.25rem" fontSize="0.5rem" opacity="1" />
          {/* <Icon as={FaPlus} fontSize="0.75rem" mr="0.25rem" /> */}
          <Text fontSize="0.85rem" fontWeight="600">
            {noItemsButtonLabel}
          </Text>
        </Button>
      )}
    </Flex>
  );
};

export default NoItemsDefaultNew;
